import { render, staticRenderFns } from "./wx-vote.vue?vue&type=template&id=3274f4fe&scoped=true&"
import script from "./wx-vote.vue?vue&type=script&lang=js&"
export * from "./wx-vote.vue?vue&type=script&lang=js&"
import style0 from "./wx-vote.vue?vue&type=style&index=0&id=3274f4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3274f4fe",
  null
  
)

export default component.exports